import { apiErrorText } from '@/shared/api'

// Машинные коды задачи (RFC 7807) → человеческий текст для тоста. 422-схемные
// ошибки huma кода не несут — их ловим inline под полем клиентской валидацией.
const map: Record<string, string> = {
  TASK_INVALID_TITLE: 'Заголовок не может быть пустым.',
  TASK_INVALID_COMPLEXITY: 'Сложность — от 1 до 10.',
  TASK_INVALID_ESTIMATE: 'Оценка в часах должна быть больше 0.',
  TASK_BUG_DETAILS_ON_TASK: 'Баг-поля доступны только у задач типа «баг».',
  TASK_EMPTY_BUG_DETAILS: 'Заполните шаги воспроизведения.',
  TASK_TREE_CYCLE: 'Нельзя перенести задачу внутрь её же поддерева.',
  TASK_PARENT_BOARD_MISMATCH: 'Родитель — с другой доски или удалён.',
  TASK_SELF_DEPENDENCY: 'Задача не может зависеть от самой себя.',
  TASK_DEPENDENCY_CYCLE: 'Такая зависимость замкнёт цикл.',
  TASK_SELF_LINK: 'Нельзя связать задачу с самой собой.',
  TASK_DUE_TIME_WITHOUT_DATE: 'Сначала выберите дату — время уточняет её.',
  TASK_REMINDER_NATURE: 'Напоминание — либо за N до срока, либо на конкретный момент.',
  TASK_INVALID_REMINDER_LEAD: 'Порог напоминания не может быть отрицательным.',
  TASK_REMINDER_IN_PAST: 'Этот момент уже прошёл.',
  TASK_DUPLICATE_REMINDER: 'Такое напоминание уже стоит.',
  TASK_TOO_MANY_REMINDERS: 'Больше десяти напоминаний на задачу не ставим.',
  TASK_NOT_FOUND: 'Задача удалена или недоступна.',
  TASK_ARCHIVED: 'Архивная задача недоступна для изменений.',
  TASK_DELETED: 'Задача удалена.',
  TASK_NOT_DONE_COLUMN: 'Сначала переместите задачу в колонку «Готово».',
  TASK_ALREADY_ARCHIVED: 'Задача уже в архиве.',
  TASK_NOT_ARCHIVED: 'Задача не в архиве.',
}

export function taskErrorText(error: unknown, fallback: string): string {
  return apiErrorText(error, map, fallback)
}
